import { Checkbox, CheckboxState } from '~/components/ui/nucleus/Checkbox';

type Props = {
  checked?: boolean;
  state?: CheckboxState;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  'aria-label'?: string;
  className?: string;
};

export const PrefCheckbox = ({
  checked = false,
  state,
  onChange,
  disabled,
  className = 'mx-auto cursor-pointer',
  'aria-label': ariaLabel,
}: Props) => {
  const value =
    state ?? (checked ? CheckboxState.CHECKED : CheckboxState.UNCHECKED);

  return (
    <span className='inline-flex justify-center' aria-label={ariaLabel}>
      <Checkbox
        value={value}
        disabled={disabled}
        className={className}
        onClick={(_, next) => onChange(next === CheckboxState.CHECKED)}
      />
    </span>
  );
};
